import { render } from "./RomaneioRelatorio.vue?vue&type=template&id=49dde20a&scoped=true"
import script from "./RomaneioRelatorio.vue?vue&type=script&lang=js"
export * from "./RomaneioRelatorio.vue?vue&type=script&lang=js"

import "./RomaneioRelatorio.vue?vue&type=style&index=0&id=49dde20a&scoped=true&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dde20a"]])

export default __exports__